// extracted by mini-css-extract-plugin
export default {"container":"productList_container__ZLTjO","heading":"productList_heading__-Z-qS"};